<template>
  <div v-if="feature.isEnabled('recruiting')">
    <div class="panel panel-default" id="recruitingMainPanel">
      <div class="panel-body">
        <div class="col-md-7" id="mapContainer">
          <GoogleMaps
            ref="recruitingGmaps"
            :checkList="checkFilterResults.SurveyInstances"
            :shopperList="shopperFilterResults.Shoppers"
            :currentFilterObject="currentFilterObject"
            @mapRadiusChanged="updateMapRadius"
            @markerInfoSelectButtonClicked="onCheckSelectionChanged"
          ></GoogleMaps>
        </div>
        <div class="col-md-5" id="checkFilterContainer">
          <CheckFilter
            ref="checkFilterRef"
            :currentFilterObject="currentFilterObject"
            :locationPropertiesList="locationPropertiesList"
            :countryList="countryList"
            @checkDataChanged="onCheckDataChanged"
            @filterUpdate="updateCheckFilter"
            @requestLocationProperties="getLocationProperties"
          ></CheckFilter>
        </div>
        <div class="col-md-5" id="shopperFilterContainer">
          <ShopperFilter
            ref="shopperFilterRef"
            :currentFilterObject="currentFilterObject"
            :locationPropertiesList="locationPropertiesList"
            :countryList="countryList"
            @shopperDataChanged="onShopperDataChanged"
            @filterUpdate="updateShopperFilter"
          ></ShopperFilter>
        </div>
        <div class="col-md-5 text-right" id="buttonBarContainer">
          <button
            type="button"
            class="btn btn-raised btn-default btn-grey pull-left"
            @click="clearFilters()"
          >
            {{ lang.RC004 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-default btn-success"
            :disabled="
              !checkFilterResults.SurveyInstanceCount &&
              !shopperFilterResults.ShopperCount
            "
            @click="
              $refs.recruitingGmaps.showChecksOnMap(),
                $refs.recruitingGmaps.showShoppersOnMap()
            "
          >
            {{ lang.RC000 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-default dialog-btn-primary"
            :disabled="isExportDisabled"
            @click="exportResults()"
          >
            {{ lang.RC001 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckFilter from "./CheckFilter";
import ShopperFilter from "./ShopperFilter";
import GoogleMaps from "./GoogleMaps";

export default {
  name: "Recruiting",
  components: {
    CheckFilter,
    ShopperFilter,
    GoogleMaps,
  },
  data() {
    return {
      currentFilterObject: {},
      checkFilterResults: {},
      shopperFilterResults: {},
      locationPropertiesList: [],
      countryList: [],
      lang: {
        RC000: "Show results on map",
        RC001: "Export",
        RC002: "Export failed",
        RC003: "Location property data request failed",
        RC004: "Clear filters",
      },
    };
  },
  computed: {
    isExportDisabled() {
      if (
        !this.checkFilterResults.SurveyInstanceCount ||
        !this.shopperFilterResults.ShopperCount ||
        this.checkFilterResults.SurveyInstanceCount *
          this.shopperFilterResults.ShopperCount >
          10000
      )
        return true;

      return false;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
    }

    this.debouncedGetShopperFilterResults = _.debounce(
      this.$refs.shopperFilterRef.getShopperFilterResult,
      600
    );
  },
  methods: {
    convertCountryList(data) {
      this.countryList = [];
      for (let country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country],
        });
      }
      this.$emit("CountryListReceived");
    },
    clearFilters() {
      this.$refs.checkFilterRef.clearCheckFilter();
      this.$refs.shopperFilterRef.clearShopperFilter();
    },
    updateCheckFilter(data) {
      this.currentFilterObject.SurveyInstance = data;
    },
    updateShopperFilter(data) {
      this.currentFilterObject.Shopper = data;
    },
    updateMapRadius(data) {
      if (!data.visible) {
        delete this.currentFilterObject.Radius;
        delete this.currentFilterObject.RadiusSurveyInstanceGuid;
        this.$refs.checkFilterRef.getCheckFilterResult();
      } else {
        this.currentFilterObject.Radius = data.radius * 1000;
      }

      if (this.debouncedGetShopperFilterResults)
        this.debouncedGetShopperFilterResults();
    },
    onCheckDataChanged($event) {
      this.checkFilterResults = $event;

      if (typeof this.currentFilterObject.Radius === "number")
        this.$refs.shopperFilterRef.getShopperFilterResult();
    },
    onShopperDataChanged($event) {
      this.shopperFilterResults = $event;
    },
    onCheckSelectionChanged($event) {
      if (!$event) return;
      if (!$event.state || !$event.guid)
        delete this.currentFilterObject.RadiusSurveyInstanceGuid;
      else this.currentFilterObject.RadiusSurveyInstanceGuid = $event.guid;

      this.$refs.checkFilterRef.getCheckFilterResult();
    },
    exportResults() {
      let query = `api/Recruiting/Export`;
      let postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.downloadFile(data[0].DownloadId);
        },
        error: () => {
          console.error("Error on POST in exportResults()");
          this.globals.showErrorSnackbar(this.lang.RC002);
        },
      });
    },
    getLocationProperties(client) {
      if (!client) {
        this.locationPropertiesList = [];
        return;
      }

      let query = `api/Recruiting/Data/LocationProperties/${client}`;
      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          this.locationPropertiesList = data;
          this.$emit("LocationPropertiesReceived");
        },
        error: () => {
          console.error("Error on GET in getLocationProperties()");
          this.globals.showErrorSnackbar(this.lang.RC003);
        },
      });
    },
  },
};
</script>

<style scoped>
#recruitingMainPanel > .panel-body,
#recruitingMainPanel > .panel-body > div {
  padding: 0 !important;
}
#mapContainer {
  height: calc(100vh - 80px);
  background: grey;
}
#checkFilterContainer {
  height: calc(50vh - 55px);
}
#shopperFilterContainer {
  height: calc(50vh - 55px);
}
#buttonBarContainer {
  height: 30px;
  background: #eee;
}

#buttonBarContainer > button {
  height: 26px;
  margin: 2px 5px 0 5px;
  padding: 0 20px 0 20px;
}
#buttonBarContainer > .btn-grey {
  background: rgb(199, 199, 199);
}
</style>



// WEBPACK FOOTER //
// Recruiting.vue?055aafeb